export default {
      id: "cross-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#cross",
      toString: function () {
        return this.url;
      }
    }